import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { SharedService } from './../shared.service';
import { Faq } from './../models/faq';
import { FormsModule, FormGroup, FormControl, FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { CustumerServiceClientEventType } from './custumer-service-client-info.event.type';
import { AppEventDispatcher } from '../../utils/AppEventDispatcher';
import { EventTypes } from '../EventTypes';
import { TweenMax, Quint } from 'gsap';
import { CustomerServiceService } from '../../master/customer-service/customer-service.service';
import { Account } from '../../autentication/models/account';
import { map, startWith } from 'rxjs/operators';
import { ThemeService } from '../theme-service/theme.service';
import { Auth } from '../../autentication/Auth';
import { Router } from '@angular/router';
import { AutenticationEventType } from '../../autentication/autentication.event.type';

@Component({
	selector: 'app-custumer-service-client-info',
	templateUrl: './custumer-service-client-info.component.html',
	styleUrls: ['./custumer-service-client-info.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class CustumerServiceClientInfoComponent implements OnInit {

	isAttendant: boolean = false;
	message: string;
	showMessageSuccess: boolean = false;

	accountsClient: Array<Account>;
	activeAccount: Account;
	activeAccount2: Account;
	formAccounts: FormGroup;

	listFaqs: Faq[] = [];

	searchFaqForm = new FormControl();
	filteredFaqs: Observable<Faq[]>;

	constructor(private router: Router, private sharedService: SharedService, private formBuilder: FormBuilder, private customerServiceService: CustomerServiceService, private themeService: ThemeService) {
		this.formAccounts = formBuilder.group({
			'account': [null, Validators.required]
		});
	}

	ngOnInit() {
		this.isAttendant = this.themeService.isAttendant();

		if (this.isAttendant) {
			this.load();
		}

		AppEventDispatcher.listen(EventTypes.CUSTUMER_SERVICE_INFO, data => {

			if (data.show) {
				this.show(data.margin);
			} else {
				this.hide();
			}
		});
	}

	hide() {
		TweenMax.to('[data-component="custumer-service-client-info"]', .8, { autoAlpha: 0, ease: Quint.easeOut });
		TweenMax.to('[data-component="custumer-service-client-info"]', .8, { delay: .8, height: 0, marginBottom: 0, padding: 0, ease: Quint.easeOut });
	}

	show(margin = true) {
		if (margin) {
			TweenMax.to('[data-component="custumer-service-client-info"]', .8, { height: 74, marginBottom: 35, padding: '16px 19px', ease: Quint.easeOut });
		} else {
			TweenMax.to('[data-component="custumer-service-client-info"]', .8, { height: 74, padding: '16px 19px', ease: Quint.easeOut });
		}
		TweenMax.to('[data-component="custumer-service-client-info"]', .8, { delay: .8, autoAlpha: 1, ease: Quint.easeOut });
	}

	load() {
		this.preload(true);
		this.accountsClient = this.customerServiceService.getAccountsClientList();

		const filteredAccounts = this._filterAccount(this.customerServiceService.getClientAccountSelected());
		this.activeAccount = filteredAccounts[0];

		this.sharedService.getListFaqs().subscribe(data => {
			this.listFaqs = data;
			this.preload(false);
		});

		this.filteredFaqs = this.searchFaqForm.valueChanges
			.pipe(
				startWith(''),
				map(question => question ? this._filter(question) : this.listFaqs.slice())
			);
	}

	private _filterAccount(accountSelected): Account[] {
		return this.accountsClient.filter(account => account.user.accountNumber === accountSelected.user.accountNumber);
	}

	displayFn(faq?: Faq): string | undefined {
		return faq ? faq.question : undefined;
	}

	private _filter(item): Faq[] {
		const filterValue = typeof item === 'string' ? item.toLowerCase() : item.question.toLowerCase();
		return this.listFaqs.filter(option => option.question.toLowerCase().indexOf(filterValue) > -1);
	}

	showModalAnswer(faq) {
		AppEventDispatcher.dispatch(EventTypes.MODAL_ANSWER.MODAL_ANSWER,
			{
				show: true,
				question: faq.question,
				answer: faq.answer
			}
		);
	}

	setAccount() {
		this.preload(true);
		this.customerServiceService.setAccount(this.activeAccount).subscribe((retorno: any) => {
			if (retorno.Sucesso) {
				this.preload(false);
				if (this.router.url === '/') {
					AppEventDispatcher.dispatch(AutenticationEventType.ACCOUNT.CHANGE_ACCOUNT, null);
				} else {
					this.router.navigate(['']);
				}
			}
		}, error => {
			this.preload(false);
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		});
	}

	addHelpDesk() {
		this.preload(true);
		this.sharedService.addHelpDesk().subscribe(data => {
			if (data.Sucesso) {
				this.preload(false);
				this.showMessageSuccess = true;
				this.message = "Chamado realizado com sucesso!";
			}
		}, error => {
			this.preload(false);
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: 'Não foi possível abrir o chamado!' });
		});
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD, { element: '[data-component="extract"] .content', show: active, delay: delay });
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/custumer-service-client-info/custumer-service-client-info.component.ts